import RenderRichText from '../RenderRichText';

import { Props } from './types';

const NoteBody = ({ note }: Props) => {
  const { body } = note;

  return <RenderRichText body={body} />;
};

export default NoteBody;
